import script from "./ChatRoomContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatRoomContent.vue?vue&type=script&setup=true&lang=ts"

import "./ChatRoomContent.vue?vue&type=style&index=0&id=65c6f416&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c6f416"]])

export default __exports__